// extracted by mini-css-extract-plugin
export default {"container":"VV-z","title":"WV-z","link":"XV-z"};